import Dashboard from "../Pages/Dashboard";
import PengaturanUnitKerja from "../Pages/Pengaturan/PengaturanUnitKerja";
import PengaturanUserRole from "../Pages/Pengaturan/PengaturanUserRole";
import {
  PengaturanGroupStaf,
  PengaturanStatusStaf,
  PengaturanTipeAbsensi,
  PengaturanTipeStaf,
} from "../Pages/Pengaturan";
import Staff from "../Pages/Staff";
import AbsenPage from "../Pages/Absen";
import DaftarCutiPage from "../Pages/Cuti";
import AssessmentIndividuPage from "../Pages/Assessment/AssessmentIndividu";
import AssessmentKelompokPage from "../Pages/Assessment/AssessmentKelompok";
import RekapIndividuPage from "../Pages/Assessment/RekapIndividu";
import RekapKelompokPage from "../Pages/Assessment/RekapKelompok";
import TandaTerima from "../Pages/TandaTerima";
import SlipGaji from "../Pages/Slip Gaji";
import AbsenStafBulananPage from "../Pages/Absen/AbsenStafBulanan";
// import AbsenTahunanPage from "../Pages/Absen/AbsenTahunan";
// import AbsenBulananPage from "../Pages/Absen/AbsenBulanan";
import Panduan from "../Pages/Panduan";
import KalenderPage from "../Pages/Kalender";
import Dokumen from "../Pages/Dokumen";
import Shift from "../Pages/Shift";
import PengaturanSlipGaji from "../Pages/Pengaturan/PengaturanSlipGaji";
import PengaturanAdmin from "../Pages/Pengaturan/PengaturanAdmin";
import PengaturanKurir from "../Pages/Pengaturan/PengaturanKurir";

export const routes = [
  { path: `${process.env.PUBLIC_URL}/dashboard`, Component: <Dashboard /> },
  { path: `${process.env.PUBLIC_URL}/staff`, Component: <Staff /> },
  { path: `${process.env.PUBLIC_URL}/tandaterima`, Component: <TandaTerima /> },
  { path: `${process.env.PUBLIC_URL}/slipgaji`, Component: <SlipGaji /> },
  // { path: `${process.env.PUBLIC_URL}/create-staff`, Component: <TambahStaff /> },
  {
    path: `${process.env.PUBLIC_URL}/absen`,
    Component: <AbsenPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/absen/:stafId/bulanan`,
    Component: <AbsenStafBulananPage />,
  },
  { path: `${process.env.PUBLIC_URL}/cuti`, Component: <DaftarCutiPage /> },
  { path: `${process.env.PUBLIC_URL}/kalender`, Component: <KalenderPage /> },
  {
    path: `${process.env.PUBLIC_URL}/dokumen`,
    Component: <Dokumen />,
  },
  {
    path: `${process.env.PUBLIC_URL}/shift`,
    Component: <Shift />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturanuserrole`,
    Component: <PengaturanUserRole />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturanunitkerja`,
    Component: <PengaturanUnitKerja />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturantipeabsensi`,
    Component: <PengaturanTipeAbsensi />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturantipestaf`,
    Component: <PengaturanTipeStaf />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturanstatusstaf`,
    Component: <PengaturanStatusStaf />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturangroupstaf`,
    Component: <PengaturanGroupStaf />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturanslipgaji`,
    Component: <PengaturanSlipGaji />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturanadmin`,
    Component: <PengaturanAdmin />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturankurir`,
    Component: <PengaturanKurir />,
  },
  {
    path: `${process.env.PUBLIC_URL}/assessment/formindividu`,
    Component: <AssessmentIndividuPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/assessment/formkelompok`,
    Component: <AssessmentKelompokPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/assessment/rekapindividu`,
    Component: <RekapIndividuPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/assessment/rekapkelompok`,
    Component: <RekapKelompokPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/panduan`,
    Component: <Panduan />,
  },
];
